export enum enumTipoParametro {
  GERAL = 'GERAL',
  FILIAL = 'FILIAL',
  USUARIO = 'USUARIO'
}

export const  tipoParametroDispositivoApenasFiliais: string[] = [
	'DEFINIR_RESPONSAVEL_ROMANEIO_APK',
  'PERMITIR_ALTERAR_ROM_INICIADO',
  'VALOR_MINIMO_ENTREGA_FILTRO',
  'EXIBIR_AREAS_RODIZIOS_VEICULOS',
  'VALIDAR_CLIENTE_SEFAZ',
  'VALIDAR_ATRASO_ENTREGA',
  'TIPO_PONTO_CHEGADA_MOTORISTA',
];

export enum TipoRoteirizacao {
  RECALCULAR_PEDIDOS_ALTERADOS = 'RECALCULAR_PEDIDOS_ALTERADOS',
  REPROCESSAR = 'REPROCESSAR'
}

